import { Chip, ChipProps } from "@mui/material";
import { globalBackground, globalColorText, globalTranslateStatusAnalysis } from "../../../shared/utils";

interface AnalysisStatusChipProps {
	status?: string | null;
	size?: ChipProps["size"];
	onClick?: ChipProps["onClick"];
	clickable?: boolean;
}

export const AnalysisStatusChip = ({
	status,
	size = "medium",
	onClick,
	clickable = false,
}: AnalysisStatusChipProps) => {
	if (!status) return null;

	return (
		<Chip
			size={size}
			label={globalTranslateStatusAnalysis(status)}
			onClick={onClick}
			clickable={clickable}
			sx={{
				color: globalColorText(status),
				fontWeight: 500,
				background: globalBackground(status),
				border: "0.5px solid #f1f1f1",
				borderRadius: "999px",
				height: size === "small" ? 26 : 30,
				"& .MuiChip-label": {
					px: size === "small" ? 1.25 : 1.75,
				},
			}}
		/>
	);
};